import { render, staticRenderFns } from "./mianzePop.vue?vue&type=template&id=466b98ac&scoped=true&"
import script from "./mianzePop.vue?vue&type=script&lang=js&"
export * from "./mianzePop.vue?vue&type=script&lang=js&"
import style0 from "./mianzePop.vue?vue&type=style&index=0&id=466b98ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466b98ac",
  null
  
)

export default component.exports